<template>
  <div class="row pb-3">
    <div class="col-12 col-md-6 order-2 order-md-1">

      <div class="form-inline">
        <h4 class="mr-2 mt-1">
          <span class="badge badge-light text-secondary">Total: {{ totalItems }}</span>
        </h4>

        <div class="input-group input-group-sm">
          <b-form-select :value="perPage" :options="pageOptions" @change="onPageSizeChange" />
          <div class="input-group-append">
            <label class="input-group-text">/ Halaman</label>
          </div>
        </div>

      </div>

    </div>

    <div class="col-12 col-md-6 order-1 order-md-2">
      <b-pagination
        pills
        align="right"
        :value="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        limit="4"
        @change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'currentPage',
    'totalItems',
    'perPage'
  ],
  data () {
    return {
      pageOptions: [5, 10, 20, 30]
    }
  },
  methods: {
    onPageChange (page) {
      this.$emit('update:currentPage', page)
    },

    onPageSizeChange (val) {
      this.$emit('update:perPage', val)
    }
  }

}
</script>